export default 'en';
export const DE = 'de';
export const HU = 'hu';